<template>
  <div class="main-page">
    <div class="head">
      <img src="../assets/zx.png" alt="">
    </div>
    <div class="searchBox">
      <div class="box">
        <input type="text" @input="iptChange" />
        <img src="../assets/search.png" alt="">

      </div>
    </div>
    <div class="radioBox">
      <div class="innerBox">
        <!-- <img src="../assets/radio.png" alt="">
        <span>不同分院因设备与仪器原因项目与价格有差异,以实际预约为准</span>
        <span>不同体检分院价格会略有差异,以实际预约价格为准。</span> -->
        <van-notice-bar background="#ffe5e5" color="#ff8282" left-icon="volume-o" text="不同分院因设备与仪器原因，项目有差异，以实际预约为准" />
      </div>

    </div>
    <div class="content">
      <div class="box-l">
        <div v-for="(item,index) in project" :key="index" :class="[curInd == index?'boxIn':'']" @click="change(index)">{{item.name}}</div>

      </div>
      <div class="box-r">
        <div class="projectBox" v-for="(item,index) in projectList" :key="index">
          <div class="projectContent">
            <img src="../assets/p.png" alt="">
            <div class="info">
              <div class="name">{{item.name}}</div>
              <div class="des" @click="open(item.des)">{{item.des}}</div>
            </div>
          </div>
          <!-- <div class="priceBox" v-if="item.price">
            <div class="p">
              <div class="num">￥{{item.price}}</div>
              <div class="txt">爱康国宾普检区价格</div>
            </div>
            <div class="vip">
              <div class="num">￥{{item.vipPrice}}</div>
              <div class="txt">爱康国宾VIP区/爱康卓悦普检区</div>
            </div>
          </div> -->
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import project from '../utils/project'
import Vue from 'vue';
import { Dialog, NoticeBar } from 'vant';
Vue.use(NoticeBar);
export default {
  data() {
    return {
      project,
      projectList: [],
      curInd: 0,
      allProjectList: []
    }
  },
  mounted() {
    console.log("3232")
    let h = document.documentElement.clientHeight;

    let boxH = document.getElementsByClassName("head")[0].clientHeight + document.getElementsByClassName('searchBox')[0].clientHeight + document.getElementsByClassName('radioBox')[0].clientHeight
    console.log(boxH)

    document.getElementsByClassName('box-r')[0].style.height = h - boxH + 'px';
    document.getElementsByClassName('box-l')[0].style.height = h - boxH + 'px';
    this.projectList = this.project[0].children;
    let allProjectList = [];
    for (let i = 0; i < this.project.length; i++) {
      for (let j = 0; j < this.project[i].children.length; j++) {
        allProjectList.push(this.project[i].children[j])
      }
    }
    this.allProjectList = allProjectList;
    console.log(allProjectList)
  },
  methods: {
    change(index) {
      this.curInd = index;
      this.projectList = this.project[index].children;
      document.getElementsByClassName('box-r')[0].scrollTop = 0;

    },
    iptChange(val) {

      let txt = val.target.value;
      let list = this.allProjectList.filter(e => {
        return e.name.indexOf(txt) != '-1'
      })
      this.projectList = list;


      this.curInd = 100;

    },
    open(des) {
      Dialog.alert({
        title: '描述',
        message: des,
        confirmButtonText: '关闭'
      }).then(() => {
        // on close
      });
    }
  }
}
</script>
<style scoped lang="scss">
.head {
  padding: 5px 0;
  background: #565555;
  position: relative;
  text-align: left;
  font-size: 0;
  img {
    width: 199px;
    position: relative;
    left: 15px;
  }
}
.searchBox {
  height: 3.4rem;
  overflow: hidden;
  padding: 0 1.5rem;

  .box {
    width: 100%;
    float: left;
    height: 3rem;
    background: #ffffff;
    border-radius: 0.5rem;
    position: relative;
    top: 0.5rem;
    img {
      width: 1.2rem;
      display: block;
      position: absolute;
      z-index: 1;
      top: 50%;
      transform: translateY(-50%);
      left: 0.8rem;
    }
    input {
      height: 100%;
      width: 100%;
      display: block;
      box-sizing: border-box;
      background: transparent;
      padding-left: 2.5rem;
      border: none;
    }
  }
}
.radioBox {
  height: 3rem;
  padding: 0 1.5rem;
  text-align: left;

  .innerBox {
    height: 2rem;
    line-height: 2rem;
    background: #ffe5e5;
    position: relative;
    // padding-left: 2rem;
    font-size: 0.8rem;
    color: #ff8282;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 0.5rem;
    overflow: hidden;
    img {
      width: 1rem;
      position: absolute;
      top: 50%;
      left: 0.5rem;
      transform: translateY(-50%);
    }
  }
}
.content {
  overflow: hidden;
  .box-l {
    float: left;
    width: 38%;
    background: #ffffff;
    text-align: left;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    box-sizing: border-box;
    padding-top: 0.5rem;
    font-size: 0.9rem;
    div {
      width: 96%;
      height: 2rem;
      line-height: 2rem;
      padding-left: 0.5rem;
      color: #333333;
      box-sizing: border-box;
    }
    .boxIn {
      background: #c99d60;
      color: #ffffff;
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
  .box-r {
    float: left;
    margin-left: 0.5rem;
    width: 60%;
    overflow-y: auto;
    padding-right: 0.3rem;
    box-sizing: border-box;
    position: relative;
    .projectBox {
      border-radius: 0.5rem;
      margin-bottom: 1rem;
      background: #ffffff;
      .projectContent {
        height: 5.5rem;
        position: relative;
        img {
          width: 4rem;
          height: 4rem;
          position: absolute;
          top: 1rem;
          left: 0.5rem;
        }
        .info {
          padding-left: 5rem;
          padding-right: 0.3rem;
          padding-top: 1rem;
          text-align: left;
          .des {
            font-size: 0.7rem;
            overflow: hidden;
            // height: 2.1rem;
            width: 100%;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            color: #999999;
          }
          .name {
            font-size: 0.9rem;
            margin-bottom: 0.2rem;
          }
        }
      }
      .priceBox {
        height: 2.8rem;
        padding-left: 1rem;
        div {
          height: 1.4rem;
          line-height: 1.4rem;
          overflow: hidden;
        }
        .p {
          .num {
            color: #ff4e6c;
            font-size: 0.8rem;
            font-weight: bold;
            float: left;
          }
          .txt {
            float: left;
            margin-left: 1rem;
            color: #333333;
            font-size: 0.7rem;
          }
        }
        .vip {
          .num {
            color: #c69c6f;
            font-size: 0.8rem;
            font-weight: bold;
            float: left;
          }
          .txt {
            float: left;
            margin-left: 1rem;
            color: #c69c6f;
            font-size: 0.7rem;
          }
        }
      }
    }
  }
}
.van-notice-bar {
  height: 100%;
}
</style>